import { Guid, LocalStorage, Level } from 'core/infrastructure';
import { Settings } from 'pos/common';

const KEY = 'pos-settings';

let currentSettings: Nullable<Settings>;

export function load(): Settings {

	if (currentSettings)
		return currentSettings;

	const jsonSettings = LocalStorage.getItem(KEY);

	currentSettings = jsonSettings ? JSON.parse(jsonSettings) as Settings : {
		machineId: '',
		posId: 0,
		languageCode: 'es',
		theme: 'light',
		logLevel: Level.INFO
	};

	if (!currentSettings.machineId) {
		currentSettings.machineId = Guid.create();
		save(currentSettings);
	}

	return currentSettings;
}

export function save(settings: Settings) {
	LocalStorage.setItem(KEY, JSON.stringify(settings));
	currentSettings = settings;
}

export function clear() {
	LocalStorage.removeItem(KEY);
}
